/** Primary business contact — used across header, footer, and pages */
export const CONTACT_PRIMARY_NAME = 'Abdikarim';

export const CONTACT_PHONE_DISPLAY = '(801) 674-8065';
export const CONTACT_PHONE_TEL = '801-674-8065';
export const CONTACT_PHONE_HREF = `tel:${CONTACT_PHONE_TEL}`;

export const CONTACT_EMAIL = 'jameshassan12@hotmail.com';
export const CONTACT_EMAIL_HREF = `mailto:${CONTACT_EMAIL}`;
